import React, { useState, useEffect } from "react";

const PartialOrderRefundForm = ({ order, orderItems, buttonStyles }) => {
  const [token, setToken] = useState("");
  const [refundFees, setRefundFees] = useState(false);
  const [refundAmounts, setRefundAmounts] = useState({});
  const [totalRefund, setTotalRefund] = useState(0);

  useEffect(() => {
    const csrf = document
      .querySelector("meta[name='csrf-token']")
      .getAttribute("content");
    setToken(csrf);
  }, []);

  const formatAmount = (amount) => {
    let dollars = amount / 100;
    return dollars.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const calculateTotalRefund = () => {
    const total = Object.values(refundAmounts).reduce(
      (acc, amount) => acc + (amount || 0),
      0
    );
    setTotalRefund(total);
  };

  const handleAmountChange = (itemId, amount) => {
    const newRefundAmounts = { ...refundAmounts, [itemId]: parseInt(amount) };
    setRefundAmounts(newRefundAmounts);
    calculateTotalRefund();
  };

  const toggleRefundFees = () => {
    setRefundFees(!refundFees);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (totalRefund > order.amount_paid) {
      alert("Refund amount cannot exceed the total amount paid.");
      return;
    }
    document.querySelector(".refund-form").submit();
  };

  return (
    <form
      className="refund-form"
      id="order-refund-form"
      method="POST"
      action={`/admin/orders/${order.id}/full_payment_refund`}
      onSubmit={handleSubmit}
    >
      <div className="heading">
        <h1 className="form-heading">Issue Full Refund</h1>
      </div>

      <div className="refund-recap">
        <div className="refund-info-box">
          <p className="field-description">Order Information:</p>
          <p className="field-content">Order ID: {order.id}</p>
          <p className="field-content">Total Paid: {formatAmount(order.amount_paid)}</p>
        </div>

        <div className="refund-info-box">
          <p className="field-description">Refund Individual Items:</p>
          {orderItems.map((item) => (
            <div key={item.id} className="refund-item">
              <label>
                {item.name} ({formatAmount(item.price)})
                <input
                  type="number"
                  min="0"
                  max={item.price}
                  value={refundAmounts[item.id] || ""}
                  onChange={(e) => handleAmountChange(item.id, e.target.value)}
                  className="refund-amount-input"
                />
              </label>
            </div>
          ))}
        </div>

        <div className="refund-info-box">
          <label>
            <input
              type="checkbox"
              checked={refundFees}
              onChange={toggleRefundFees}
            />
            Refund Fees
          </label>
        </div>

        <div className="refund-info-box">
          <p className="field-description">Total Refund Amount:</p>
          <p className="field-content">{formatAmount(totalRefund)}</p>
        </div>
      </div>

      <div className="refund-row">
        <input type="hidden" name="utf8" value="✓" />
        <input
          type="hidden"
          name="authenticity_token"
          value={token}
        />
        <input
          type="hidden"
          name="refund[order_id]"
          value={order.id}
        />
        <input
          type="hidden"
          name="refund[refund_fees]"
          value={refundFees}
        />
        <input
          type="hidden"
          name="refund[total_amount]"
          value={totalRefund}
        />
      </div>

      <div className="button-row">
        <button
          type="submit"
          className="button button-primary refund-button"
          style={buttonStyles}
        >
          Confirm Refund
        </button>
      </div>
    </form>
  );
};

export default PartialOrderRefundForm;

